<script>
    export default {
        name: "BrandTimelineLabel",
        props: {
            label: Object,
        },
        methods: {
            onYearClick(year) {
                this.$emit("on-year-click", year);
            },
            onProductClick(slug) {
                this.$emit("on-product-click", { year: this.label.title, slug });
            },
        },
    };
</script>

<template>
    <div
        class="brand-timeline-label"
        :style="{ flexGrow: label.isActive ? 0 : label.products.length }"
    >
        <button
            class="brand-timeline-label__year outline"
            :class="{ 'is-active': label.isActive }"
            @click="onYearClick(label.title)"
        >
            {{ label.title }}
        </button>

        <button
            class="brand-timeline-label__product outline"
            :class="{ 'is-visible': product.isVisible, 'is-active': product.isActive }"
            v-for="product in label.products"
            :key="product.slug"
            @click="onProductClick(product.slug)"
            :tabindex="product.isVisible ? 0 : -1"
        >
            <span>{{ product.title }}</span>
        </button>
    </div>
</template>

<style lang="scss">
    .brand-timeline-label {
        @include bp($bp-desktop-lg) {
            display: flex;
            flex-grow: 1;
            transition: all 0.5s ease-in;
        }
    }
    .brand-timeline-label__year {
        @include bp($bp-desktop-lg) {
            position: relative;
            width: 40px;
            height: 20px;
            font-size: 16px;
            font-weight: 700;
            text-align: center;
            cursor: pointer;
            transition: opacity 0.5s ease-in;
            &::before {
                content: "";
                position: absolute;
                bottom: -5px;
                left: 20px;
                width: 5px;
                height: 5px;
                background-color: #000;
                transform: translateX(-50%);
                transition: transform 0.2s ease-in;
            }
            &.is-active {
                color: #417abd;
                pointer-events: none;
            }
        }
    }

    .brand-timeline-label__product {
        @include bp($bp-desktop-lg) {
            position: relative;
            top: 35px;
            flex-grow: 1;
            min-width: 20px;
            font-weight: 700;
            line-height: 19px;
            white-space: nowrap;
            font-size: 0;
            text-transform: uppercase;
            transition: all 0.5s ease-in;
            pointer-events: none;
            opacity: 1;
            span {
                position: relative;
                top: 0;
                text-align: center;
                transform: scale(0);
                opacity: 0;
                transition: opacity 0.5s ease-in, transform 0.2s ease-in;
            }
            &::before {
                content: "";
                position: absolute;
                top: -8px;
                left: 50%;
                width: 5px;
                height: 5px;
                background-color: #000;
                transform: translateX(-50%);
                transition: transform 0.5s ease-in;
            }
            &.is-active {
                color: #417abd;
                &::before {
                    transform: translateX(-50%) scaleX(3);
                }
            }
            &.is-active.is-visible {
                pointer-events: none;
            }
            &.is-visible {
                flex-grow: 0;
                margin: 0 12px;
                font-size: 14px;
                cursor: pointer;
                pointer-events: auto;
                opacity: 1;
                span {
                    opacity: 1;
                    transform: scale(1);
                }
            }
        }
    }
</style>
